(() => {
  let ProductPage = () => {
    let isProductPage = document.querySelector('.template-product');
    if (!isProductPage) {
      return;
    }

    var mq_small = window.matchMedia('(max-width: 768px)');
    let UpdateProductPageView = () => {
      let isMobile = mq_small.matches;

      if (isMobile) {
        document.querySelector('[data-product-images]').insertAdjacentElement('beforebegin', document.querySelector('.breadcrumb'));
        document.querySelector('.product-block--header').insertAdjacentElement('beforebegin', document.querySelector('.stamped-product-reviews-badge'));
        document.querySelector('.product-block--header').insertAdjacentElement('beforeend', document.querySelector('.product-block--price'));
      }
      else {
        document.querySelector('.product-block--header').insertAdjacentElement('beforebegin', document.querySelector('.breadcrumb'));
        document.querySelector('.breadcrumb').insertAdjacentElement('afterend', document.querySelector('.stamped-product-reviews-badge'));
        document.querySelector('[data-product-blocks]').insertAdjacentElement('afterbegin', document.querySelector('.product-block--price'));
      }

      if (!document.querySelector('.highlight-sales-point')) {
      document.querySelector('.product-block--sales-point').insertAdjacentHTML('beforebegin', '<div class="highlight-sales-point"></div>');
        let $sales_points = document.querySelectorAll('.product-block--sales-point');
        Array.from($sales_points).forEach((item, index) => {
          if (index < $sales_points.length - 1) {
            document.querySelector('.highlight-sales-point').insertAdjacentElement('beforeend', item);
          }
        }); 
      }
    }

    mq_small.onchange = (e) => {
      UpdateProductPageView();
    }
    UpdateProductPageView();
  }

  let CollectionColorSwatches = () => {
    document.querySelectorAll('.linked-color-swatches .color-swatch').forEach(($swatch) => { 
      $swatch.addEventListener('click', (e) => { 
        let $swatchesWrap = $swatch.closest('.linked-color-swatches');
        $swatchesWrap.querySelector('.selected').classList.remove('selected');
        $swatch.classList.add('selected');
        
        let $grid = e.currentTarget.closest('.grid-product');
        if ($grid) {
          let $image = $grid.querySelector('.grid-product__image');
          if ($image) {
            $image.removeAttribute('data-srcset');
            $image.removeAttribute('srcset');
            $image.src = e.currentTarget.dataset.image;
            AOS.refreshHard();
          }
        }
      });
    });
  }

  let postFormData = async (form) => {
    let url = form.action;
    let formData = new FormData(form);
    let formdata_json = {};
    formData.forEach((value, key) => {
      if (formdata_json.hasOwnProperty(key)) {
        formdata_json[key] = [].concat(formdata_json[key], value);
      }
      else {
        formdata_json[key] = value;
      }
    });

    const response = await fetch(url, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formdata_json)
    });
    return response;
  }

  let GetItWithoutGraphics = () => {
    var QuickShipModal = new theme.Modals('QuickShopModal', 'quickshop-modal', {
      solid: true
    });

    // Modal open
    document.querySelectorAll('[data-quickshoptrigger]').forEach(($btn) => { 
      $btn.addEventListener('click', (e) => {
        QuickShipModal.open();
      });
    });

    // Add to cart
    document.querySelectorAll('#QuickShopModal [data-add-to-cart]').forEach(($btn) => { 
      $btn.addEventListener('click', (e) => {
        e.preventDefault();
        let $form = e.currentTarget.closest('form');
        postFormData($form)
          .then((res) => {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          })
          .catch(console.error);
      })
    });
  }

  const PromoGridCarousel = () => {
    document.querySelectorAll('.promo-grid-swiper').forEach(($promoGridSwiper) => {
      console.log($promoGridSwiper.dataset.autoplay);
      var swiper = new Swiper($promoGridSwiper, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centerSlides: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: parseInt($promoGridSwiper.dataset.autoplay) * 1000
        }      
      });
    });
  }

  const CollectionGrouped = () => {
    let ToggleView = () => {
      let isFilteredView = document.querySelectorAll('.tag-list--active-tags .tag--remove').length !== 0;
      let $blocks = document.querySelector('[data_blocks]');
      if ($blocks) {
        $blocks.classList.toggle('hide', isFilteredView);
      }

      let $product_grid = document.querySelector('[data-main_grid]');
      if ($product_grid) {
        $product_grid.classList.toggle('hide', !isFilteredView);
      }
    }

    // on page load
    ToggleView();

    // when filter is active, show default products
    document.addEventListener('filter:active', (e) => {
      //console.log(e);
      ToggleView();
    });
  }
  
  const DOMReady = () => {
    ProductPage();
    CollectionColorSwatches();
    GetItWithoutGraphics();
    PromoGridCarousel();
    CollectionGrouped();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();